import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

interface RouterProps {
  location: ReturnType<typeof useLocation>;
  navigate: ReturnType<typeof useNavigate>;
  params: ReturnType<typeof useParams>;
}

export interface WithRouterProps {
  router: RouterProps;
}

function withRouter<P extends object>(Component: React.ComponentType<P & WithRouterProps>) {
  function ComponentWithRouterProp(props: P) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }
  return ComponentWithRouterProp;
}

export default withRouter;
